export type ProductionConfig = {
  headers: Record<string, string>;
};

export const productionConfig: ProductionConfig = {
  headers: {}
};
